
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserRelationshipType } from '@next/core-lib/business-partner-aggregation-api';
import {
  AbstractDialogResultData,
  AbstractDialog,
  AbstractDialogData,
} from '@next/core-lib/dialog';

import { Store } from '@ngrx/store';

import { SiteState } from '../../../shared/models';

import { GetAdvicesForCustomer } from '../../store/actions';

@Component({
  templateUrl: './select-customer-dialog.component.html',
  standalone: false,
})
export class SelectCustomerDialogComponent extends AbstractDialog<{
  customerId?: number;
  locationId?: number;
}> {
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  private readonly store = inject<Store<SiteState>>(Store);
  protected readonly mdDialogRef = inject<MatDialogRef<SelectCustomerDialogComponent, AbstractDialogResultData<never>>>(MatDialogRef);

  relatedType: UserRelationshipType = UserRelationshipType.Customer;
  confirm(result: { customerId?: number; locationId?: number }) {
    this.store.dispatch(new GetAdvicesForCustomer(result.customerId));
  }
}
